// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slice--text-with-image[data-v-19aea06b] img{margin-bottom:.5rem;max-width:50%}.slice--text-with-image[data-v-19aea06b] img.align-left{float:left;margin-right:1.5rem}.slice--text-with-image[data-v-19aea06b] img.align-right{float:right;margin-left:1.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
